import React, {useEffect} from 'react'
import {ElementShapeType} from '../../../entities/project'
import {KonvaNodeEvents, Layer} from 'react-konva'
import {Node as NodeRef, NodeConfig} from 'konva/lib/Node'
import {getRelativePointerPosition} from '../util'

export function PlantingToolLayer({
  onElementDrawn,
}: {
  onElementDrawn: (shape: {type: ElementShapeType; props: NodeConfig}) => void
}) {
  const layerRef = React.useRef<NodeRef>(null)

  useEffect(() => {
    const onClick: KonvaNodeEvents['onClick'] = (e) => {
      const {x, y} = getRelativePointerPosition(e.target)
      onElementDrawn({
        type: 'image',
        props: {
          x: Math.floor(x),
          y: Math.floor(y),
          width: 150,
          height: 150,
        },
      })
    }

    const stage = layerRef.current.getStage()

    stage.on('click', onClick)

    return () => {
      if (stage) {
        stage.off('click', onClick)
      }
    }
  }, [onElementDrawn])

  return <Layer ref={layerRef as any} />
}
